<mat-form-field class="chip-list" appearance="outline">
	<mat-label color="primary">Tags +</mat-label>
	<mat-chip-list #chipList aria-label="Tag selection">
		<mat-chip color="primary" selected *ngFor="let tag of tags" (removed)="remove(tag)">
			{{ tag.name }}
			<button [disableRipple]="true" matChipRemove>
				<mat-icon>cancel</mat-icon>
			</button>
		</mat-chip>
		<input #tagInput placeholder="New tag..." [matChipInputFor]="chipList" [formControl]="tagChipsCtrl" [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)" />
	</mat-chip-list>
	<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
		<mat-option *ngFor="let tag of filteredTagsReversed" [value]="tag">
			{{ tag.name }}
		</mat-option>
	</mat-autocomplete>
</mat-form-field>
